// extracted by mini-css-extract-plugin
export default {"scrollX":"Calendar_scrollX__8+ycO","tableMain":"Calendar_tableMain__of5n0"};